import { put, takeEvery, all, select } from 'redux-saga/effects';
import * as constants from '../constants/exam';
import * as examPageAction from '../actions/exam';
// import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { ExamService } from '../../api/exam-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';

import Translator from '../../core/i18n';
import { IGetAddExam } from '../../models/action/exam';
import { GetActivitiesType } from '../../models/enums/GetActivityType';
const T = Translator.create();
const _logger = Log.create('Exam Saga');
const _examService = new ExamService();
const getCoursePageState = (state: { coursePage: any; }) => state.coursePage;

export interface IResponseGenerator {
    config?:any;
    data?:any;
    headers?:any;
    request?:any;
    status?:number;
    statusText?:string;
}

function* setAddExamActivity(params: IGetAddExam) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        params.examData.examExternalSecurityProfile = params.examData.isUseExamExternalSecurity ? params.examData.examExternalSecurityProfile : '';
        const _yield = _examService.RequestAddExamActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
            if (params.callback) {
                params.callback(null);
            }
        }
        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.examData.activityId 
                        ? T.t('r_update_activity_succesful_notification') 
                        : T.t('r_add_activity_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            const redirectPageParams: any = { 
                submitValues: params.examData,
                activityId: params.examData.activityId ? params.examData.activityId : pageData,
                termWeekId:
                    params.examData.termWeekIds && params.examData.termWeekIds[0] !== '0'
                        ? params.examData.termWeekIds[0]
                        : params.examData.termWeekIds[1]
            };
            yield put(examPageAction.addExamSetAction(null));
            if (params.callback) {
                params.callback(redirectPageParams);
            }
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        if (params.callback) {
            params.callback(null);
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* setExamActivity(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        yield put(examPageAction.addExamSetAction(null));
        const coursePage = yield select(getCoursePageState);

    if(coursePage.classes?.classes?.length <= 0){
        params.getActivityType = GetActivitiesType.Course;

    }
    
        const pageData = yield _examService.RequestGetExamAsync({ ...params, take: 20, skip: 0 })
        .then((response: Response) => {
            return response;
        })
        .then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        })
        .then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        })
        .then((data: any | null) => {
            if (!data) {
                return null;
            } else {
                return data;
            }
        });

        yield setExamActivityErrorSituation(isError, errorList, pageData, params.spinnerId);
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setExamActivityErrorSituation(isError: boolean, errorList: any, pageData: any, spinnerId: string ): any {
    if(isError) {
        errorList ? 
        Object.keys(errorList).forEach((key: any) => {
            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
        }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

        return false;
    } else {
        yield put(examPageAction.addExamSetAction(pageData, spinnerId, 'set'));
        return true;
    }
}

function* getMyExams(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _examService.RequestGetMyExamsAsync(params.Filters).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_exam_page_my_error_message'), 'topRight');
        }
        if (!isError) {
            yield put(examPageAction.getMyExamsSetAction(pageData, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_exam_page_my_error_message'), 'topRight');
    }
}

function* getMyExamMessages(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _examService.RequestGetMyExamMessagesAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        }
        if (!isError) {
            yield put(examPageAction.setExamMessages(pageData, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
    }
}

function* watchGetAddExamActivity() {
    yield takeEvery(constants.actions.ADD_EXAM_ACTIVITY, setAddExamActivity);
    return null;
}

function* watchSetExamActivity() {
    yield takeEvery(constants.actions.ADD_EXAM_UPDATE_ACTIVITY, setExamActivity);
    return null;
}

export function* watchGetMyExams() {
    yield takeEvery(constants.actions.GET_MY_EXAMS, getMyExams);
}
export function* watchGetMyExamMessages() {
    yield takeEvery(constants.actions.GET_EXAM_MESSAGES, getMyExamMessages);
}

export function* ExamSagas() {
    yield all([
        watchGetAddExamActivity(),
        watchSetExamActivity(),
        watchGetMyExams(),
        watchGetMyExamMessages()
    ]);
}